<template lang="pug">
  main
    NavBarInventario
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns.has-text-centered.has-text-dark
          .column
            h1.is-size-3 Inventario de Administración
              | 
              a.button.is-black.is-rounded(@click="backPage")
                i.fas.fa-times
            br
        .columns.is-centered.has-text-dark
          .column.card-item.is-2-desktop.is-2-tablet.is-12-mobile.has-text-centered(v-show="verTodo")
            span.icon.is-large.is-size-6
              span.fa-stack.fa-lg
                i.fas.fa-circle.fa-stack-2x
                i.fas.fa-tags.fa-stack-1x.fa-inverse
            p.has-text-weight-medium.is-size-5 Tags
            br
            a.button.is-dark.is-rounded(@click="irAsignaciones('tag')") Entrar
          .column.card-item.is-2-desktop.is-2-tablet.is-12-mobile.has-text-centered(v-show="verTodo")
            span.icon.is-large.is-size-6
              span.fa-stack.fa-lg
                i.fas.fa-circle.fa-stack-2x
                i.fas.fa-gas-pump.fa-stack-1x.fa-inverse
            p.has-text-weight-medium.is-size-5 Combustibles
            br
            a.button.is-dark.is-rounded(@click="irAsignaciones('s')") Entrar
          .column.card-item.is-2-desktop.is-2-tablet.is-12-mobile.has-text-centered(v-show="verTodo")
            span.icon.is-large.is-size-6
              span.fa-stack.fa-lg
                i.fas.fa-circle.fa-stack-2x
                i.fas.fa-mobile-alt.fa-stack-1x.fa-inverse
            p.has-text-weight-medium.is-size-5 Celulares
            br
            a.button.is-dark.is-rounded(@click="irAsignaciones('c')") Entrar
        .columns.is-centered.has-text-dark
          .column.card-item.is-2-desktop.is-2-tablet.is-12-mobile.has-text-centered(v-show="verMobiliario || verTodo")
            span.icon.is-large.is-size-6
              span.fa-stack.fa-lg
                i.fas.fa-circle.fa-stack-2x
                i.fas.fa-couch.fa-stack-1x.fa-inverse
            p.has-text-weight-medium.is-size-5 Mobiliario
            br
            a.button.is-dark.is-rounded(@click="irAsignaciones('m')") Entrar
          .column.card-item.is-2-desktop.is-2-tablet.is-12-mobile.has-text-centered(v-show="verConsumibles")
            span.icon.is-large.is-size-6
              span.fa-stack.fa-lg
                i.fas.fa-circle.fa-stack-2x
                i.fas.fa-clipboard-list.fa-stack-1x.fa-inverse
            p.has-text-weight-medium.is-size-5 Consumibles
            br
            router-link.a.button.is-dark.is-rounded.is-size-6(to="/Inventario/Cedes/Consumibles") Entrar
        
          .column.card-item.is-2-desktop.is-2-tablet.is-12-mobile.has-text-centered(v-show="verHerramientas || verTodo")
            span.icon.is-large.is-size-6
              span.fa-stack.fa-lg
                i.fas.fa-circle.fa-stack-2x
                i.fas.fa-tools.fa-stack-1x.fa-inverse
            p.has-text-weight-medium.is-size-5 Herramientas
            br
            a.button.is-dark.is-rounded(@click="irAsignaciones('h')") Entrar
          .column.card-item.is-2-desktop.is-2-tablet.is-12-mobile.has-text-centered(v-show="verTodo || verTransportes")
            span.icon.is-large.is-size-6
              span.fa-stack.fa-lg
                i.fas.fa-circle.fa-stack-2x
                i.fas.fa-shuttle-van.fa-stack-1x.fa-inverse
            p.has-text-weight-medium.is-size-5 Transporte
            br
            a.button.is-dark.is-rounded(@click="irAsignaciones('t')") Entrar
        .columns.is-centered.has-text-dark
          .column.card-item.is-2-desktop.is-2-tablet.is-12-mobile.has-text-centered(v-show="verSistemas")
            span.icon.is-large.is-size-6
              span.fa-stack.fa-lg
                i.fas.fa-circle.fa-stack-2x
                i.fas.fa-laptop.fa-stack-1x.fa-inverse
            p.has-text-weight-medium.is-size-5 Sistemas y Telecom.
            br
            a.button.is-dark.is-rounded(@click="goAsignacionesArea('s')") Entrar
            br
          .column.card-item.is-2-desktop.is-2-tablet.is-12-mobile.has-text-centered(v-show="verMaquinaria || verTodo")
            span.icon.is-large.is-size-6
              span.fa-stack.fa-lg
                i.fas.fa-circle.fa-stack-2x
                i.fas.fa-wrench.fa-stack-1x.fa-inverse
            p.has-text-weight-medium.is-size-5 Maquinaria
            br
            router-link.a.button.is-dark.is-rounded.is-size-6(to="/Inventario/Maquinaria") Entrar
            br
          .column.card-item.is-2-desktop.is-2-tablet.is-12-mobile.has-text-centered(v-show="verAlmacen")
            span.icon.is-large.is-size-6
              span.fa-stack.fa-lg
                i.fas.fa-circle.fa-stack-2x
                i.fas.fa-shopping-cart.fa-stack-1x.fa-inverse
            p.has-text-weight-medium.is-size-5 Almacén
            br
            router-link.a.button.is-dark.is-rounded.is-size-6(to="/Almacenes") Entrar
            br
        .columns.is-centered.has-text-dark
          .column.card-item.is-2-desktop.is-2-tablet.is-12-mobile.has-text-centered(v-show="verBusqueda")
            span.icon.is-large.is-size-6
              span.fa-stack.fa-lg
                i.fas.fa-circle.fa-stack-2x
                i.fas.fa-search.fa-stack-1x.fa-inverse
            p.has-text-weight-medium.is-size-5 Busqueda
            br
            router-link.a.button.is-dark.is-rounded.is-size-6(to="/Inventario/Busqueda/Avanzada") Entrar
            br
        .columns(v-show="verBotonDescargas")
          .column.has-text-right
            a.button.is-black.is-rounded(@click="downAsignaciones")
              span.icon
                i.fas.fa-file-download
              | &nbspAsignaciones
            | &nbsp
            a.button.is-success.is-rounded(@click="downActivos")
              span.icon
                i.fas.fa-file-download
              | &nbspActivos
</template>


<script>
  import Loader from '@/components/shared/Loader.vue'
  import NavBarInventario from './layout/NavBarInventario.vue'
  import InventarioServices from '../../services/inventario/inventario'
  import { mapState } from 'vuex'

  export default {
    name: 'Menu',
    components: { Loader, NavBarInventario },
    data() {
      return {
        isLoading: false,
        verTodo: false,
        verSistemas: false,
        verConsumibles: false,
        verTransportes: false,
        verMobiliario: false,
        verHerramientas: false,
        verMaquinaria: false,
        verAlmacen: false,
        verBusqueda: false,
        verBotonDescargas: false,
      }
    },
    methods: {
      irAsignaciones(tipo) {
        this.$store.commit('showAreaAsignacion', `a${tipo}`)
        this.$router.push( {path: '/Inventario/Asignaciones'})
      },
      obtenerUser() {
        if (Object.keys(this.userLogin).length === 0) {
          this.$router.push('/')
        } else {
          switch (this.userLogin.cargo) {
            case '000':
              this.verTodo = true
              this.verSistemas = true
              this.verBotonDescargas = true
              break
            case '002':
              this.verTodo = true
              this.verSistemas = true
              this.verBotonDescargas = true
              this.verAlmacen = true
              this.verBusqueda = true
              break
            case '120':
              return false
              break
            case '2100':
              this.verTodo = true
              this.verSistemas = true
              this.verBotonDescargas = true
              break
            case '2200':
              this.verTodo = true
              this.verSistemas = true
              this.verBotonDescargas = true
              this.verAlmacen = true
              break
            case '003':
              this.verTodo = true
              this.verSistemas = true
              this.verBotonDescargas = true
              break
            case '210':
              this.verTodo = true
              this.verBotonDescargas = true
            case '230':
              this.verTodo = true
              this.verBotonDescargas = true
            case '330':
              this.verTodo = true
              this.verBotonDescargas = true
              break
            case '331':
              this.verTodo = true
              this.verBotonDescargas = true
            break
            case '332':
              this.verTodo = true
              this.verBotonDescargas = true
            break
            case '160':
              return false
              break
            case '240':
              return false
              break
            case '241':
              this.verSistemas = true
              this.verMobiliario = true
              this.verConsumibles = true
              this.verHerramientas = true
              break
            case '310':
              return false
              break
            case '321':
              this.verHerramientas = true
              this.verMobiliario = true
              break
            case '323':
              this.verTodo = true
              this.verSistemas = true
              this.verBotonDescargas = true
              break
            case '324':
              this.verTransportes = true
              break
            case '341':
              return false
              break
            case '342':
              return false
              break
            case '343':
              return false
              break
            case '350':
              return false
              break
            case '250':
              return false
              break
            case '370':
              return false
              break
            case '372':
              this.verTodo = true
              break
            case '270':
              return false
              break
            default:
              this.verTodo = false
              this.verSistemas = false
              this.verTransportes = false
              this.verHerramientas = false
              this.verMaquinaria = false
              this.verConsumibles = false
              this.verBotonDescargas = false
              this.verAlmacen = false
              this.verBusqueda =  false
            break
            }
        }
      },
      goAsignacionesArea(area) {
        this.$store.commit('showAreaAsignacion', area)
        this.$router.push('/Inventario/Asignaciones')
      },
      backPage() {
        this.$router.back()
      },
      downActivos () {
        this.isLoading = true
        const currentUrl = window.location.hostname
        InventarioServices.createExcel_Activos()
          .then((res) => {
            console.log(res)
              if (res.success) {
                open(`https://${currentUrl}/reportesApp/server/excel/generarResguardo_All.php?nameFile=${res.file}`, '_blank')
                setTimeout(() => {
                  InventarioServices.borrarFile_InventarioUser(res.file)
                    .then( resDel => {
                      this.isLoading = false
                      console.log(resDel)
                    })
                }, 4000)
              } else {
                this.isLoading = false
                console.log(res.respuesta)
              }
          })
          .catch((error) => {
            this.isLoading = false
            this.displayToast('bubble',`Error: ${error}`, 'ban', 'OK')
          })
      },
      downAsignaciones () {
        this.isLoading = true
        const currentUrl = window.location.hostname
        InventarioServices.descargarAsignaciones(true, true, true, true, false, true, true, true, true, true, true, true, true, false)
          .then((res) => {
            console.log(res)
              if (res.success) {
                open(`https://${currentUrl}/reportesApp/server/excel/generarResguardo_All.php?nameFile=${res.file}`, '_blank')
                setTimeout(() => {
                  InventarioServices.borrarFile_InventarioUser(res.file)
                    .then( resDel => {
                      this.isLoading = false
                      console.log(resDel)
                    })
                }, 4000)
              } else {
                this.isLoading = false
                console.log(res.respuesta)
              }
          })
          .catch((error) => {
            this.isLoading = false
            this.displayToast('bubble',`Error: ${error}`, 'ban', 'OK')
          })
      },
    },
    computed: {
    ...mapState(['logueado', 'userLogin'])
    },
    created () {
      this.obtenerUser()
    }
  }
</script>

<style lang="scss" scoped>
  .card-item:hover {
    transform: translateY(-5px) scale(1.005) translateZ(0);
    box-shadow: 0 24px 36px rgba(0,0,0,0.11), 0 14px 16px rgba(0,0,0,0.11);
  }
</style>


// WEBPACK FOOTER //
// src/components/inventario_Componentes/SubMenuAdmon.vue